<div class="class-message" [formGroup]="group">
  <div class="class-message__actions">
    <div class="class-message__actions--enabled">
      <app-enfaf-switch-dark
        [disabled]="!messageOptions.length"
        [control]="group.controls['enabled']"
        [matTooltip]="!messageOptions.length ? 'No se han definido mensajes para: Hito al finalizar una clase.' : ''"
      />
      <span>{{ label }}</span>
    </div>

    <div class="class-message__actions--template-selector">
      <enfaf-select label="Selecciona un mensaje" name="messageId" [control]="group.controls['messageId']" [options]="messageOptions"> </enfaf-select>
    </div>
  </div>

  @if (botInfo) {
    <div class="class-message__template">
      {{ botInfo }}
    </div>
  }
</div>
